module.exports = __webpack_public_path__ + "img/logo.cf23526f.png";